import { ONLYOFFICE_URL } from './editorApi';

let loaderPromise = null;

/**
 * Inject the Document Server's DocsAPI script exactly once and resolve with the
 * global `DocsAPI`. Subsequent calls reuse the same promise (or the already-set
 * global), so mounting multiple editors never double-loads the script.
 */
export function loadDocsApi(documentServerUrl) {
  const base = (documentServerUrl || ONLYOFFICE_URL || '').replace(/\/+$/, '');

  if (window.DocsAPI) return Promise.resolve(window.DocsAPI);
  if (loaderPromise) return loaderPromise;
  if (!base) return Promise.reject(new Error('Document Server URL is not configured'));

  loaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${base}/web-apps/apps/api/documents/api.js`;
    script.async = true;
    script.onload = () => {
      if (window.DocsAPI) {
        resolve(window.DocsAPI);
      } else {
        // Script loaded but the global never appeared (e.g. a proxy served an
        // error page as JS). Clear the singleton so a later attempt can retry.
        loaderPromise = null;
        reject(new Error('DocsAPI failed to initialize'));
      }
    };
    script.onerror = () => {
      loaderPromise = null; // allow a retry after a transient failure
      reject(new Error('Failed to load the Document Server script'));
    };
    document.head.appendChild(script);
  });
  return loaderPromise;
}
